"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorMessage = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var ErrorMessageStateContext = React.createContext(undefined);
var ErrorMessageProvider = function (_a) {
    var children = _a.children, errorMessage = _a.errorMessage;
    return ((0, jsx_runtime_1.jsx)(ErrorMessageStateContext.Provider, { value: { errorMessage: errorMessage }, children: children }));
};
var useErrorMessage = function (props) {
    if (props === void 0) { props = { isErrorMessageProviderRequired: true }; }
    var context = React.useContext(ErrorMessageStateContext);
    if (context === undefined) {
        if (!props.isErrorMessageProviderRequired) {
            return { errorMessage: undefined };
        }
        throw new Error('useErrorMessage must be used within an ErrorMessageProvider');
    }
    return context;
};
exports.useErrorMessage = useErrorMessage;
exports.default = ErrorMessageProvider;
//# sourceMappingURL=ErrorMessageProvider.js.map